import $ from "jquery";

function ToggleAllSwitches() {
  // 一括選択クリック時
  $(".js-switch-control-all").on("click", function () {
    $(".js-switch-control").prop("checked", this.checked);
  });
  // 各スイッチクリック時
  $(".js-switch-control").on("click", function () {
    if ($(".js-switch-control").length == $(".js-switch-control:checked").length) {
      $(".js-switch-control-all").prop("checked", true);
    } else {
      $(".js-switch-control-all").prop("checked", false);
    }
  });
}

export { ToggleAllSwitches };
